import React from 'react'
import SectionHeader from './SectionHeader'
import SectionDetail from './SectionDetail'
import SeperatorLine from '../../SeperatorLine'
import Text from '../../Text'
import Spacer from '../../Spacer'
import styles from './styles.module.css'

function ProductDetails(props) {
  const { title, sections = [] } = props

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Spacer size={96} />
        <h2 className={styles.title}>
          <Text type="h3">{title}</Text>
        </h2>
        <div className={styles.details}>
          {sections.map((section, index) => {
            const isLast = index + 1 === sections.length
            const nextIsHeader = !isLast && sections[index + 1]._type === 'header'
            const components = []
            switch(section._type) {
              case 'header':
                components.push(<SectionHeader data={section} key={section._key}/>)
                break
              case 'detail':
                components.push(<SectionDetail data={section} key={section._key}/>)
                break
              default:
                break
            }

            if (!isLast && !nextIsHeader && section._type !== 'header') {
              components.push(<SeperatorLine key={section._key + '_seperator'}/>)
            }

            return components
          })}
        </div>
      </div>
      <Spacer size={96} />
    </div>
  )
}

export default ProductDetails
